/* DillySocks — Sticky Filter-Button (Kollektionsseiten, Mobile + Desktop).

   Schwebender Filter-Button (FAB) unten rechts (Sean 10.09.: auch auf
   Desktop mitwandern lassen):
   - erscheint, sobald der jeweils sichtbare Filter-Zugang nach OBEN aus
     dem Viewport gescrollt ist (IntersectionObserver) — Mobile ist das
     die Filter-/Sortierleiste (.facets-toggle), Desktop der in die
     Facetten-Spalte injizierte .ds-ftb-Button (die Toggle-Leiste ist
     dort unsichtbar und taugt nicht als Anker),
   - verschwindet, sobald sie wieder sichtbar ist,
   - Klick übernimmt exakt die Funktion des regulären Buttons: er klickt
     den echten .facets-toggle__button (öffnet den Filter-Drawer mit allen
     Facetten) — keine eigene Drawer-Logik, kein Duplikat.
   - Badge/Active-State kommen zentral aus ds-nav.js (dsSyncFilterButtons,
     eine Zaehlung fuer alle Filter-Buttons); hier wird nach AJAX-Filter-
     Updates und History-Navigation nur neu angestossen.

   Ein-/Ausblenden über CSS-Klasse .is-visible (Animation + pointer-events
   in dillysocks-tokens.css, Timing aus den Theme-Tokens). */
(function () {
  'use strict';

  var fab = null;
  var io = null;
  var observedToggle = null;

  function realButton() {
    return document.querySelector('.facets-toggle__button');
  }
  function toggleRow() {
    /* Sichtbaren Anker waehlen: offsetParent null = display:none (Mobile-
       Leiste auf Desktop bzw. Desktop-Button im zugeklappten Drawer). */
    var candidates = [
      document.querySelector('.facets-toggle'),
      document.querySelector('.ds-ftb'),
      realButton(),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && candidates[i].offsetParent !== null) return candidates[i];
    }
    return candidates[0] || candidates[1] || candidates[2];
  }

  /* Zaehlung + Badge kommen zentral aus ds-nav.js (window.dsSyncFilterButtons
     setzt .is-active und .ds-filter-badge auf Toggle, Desktop-Button UND
     diesem FAB) — hier nur anstossen. */
  function updateBadge() {
    if (typeof window.dsSyncFilterButtons === 'function') window.dsSyncFilterButtons();
  }

  function setVisible(on) {
    if (!fab) return;
    fab.classList.toggle('is-visible', on);
    fab.setAttribute('aria-hidden', on ? 'false' : 'true');
    fab.tabIndex = on ? 0 : -1;
  }

  function ensureFab() {
    if (fab) return fab;
    fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'ds-filter-fab';
    fab.setAttribute('aria-label', 'Filter öffnen');
    fab.setAttribute('aria-hidden', 'true');
    fab.tabIndex = -1;
    fab.innerHTML =
      '<i class="fa-solid fa-sliders" aria-hidden="true"></i>' +
      '<span>Filter</span>';
    fab.addEventListener('click', function () {
      var btn = realButton();
      if (btn) btn.click();
    });
    document.body.appendChild(fab);
    return fab;
  }

  function observe() {
    var row = toggleRow();
    if (!row || row === observedToggle) return;
    if (io) io.disconnect();
    observedToggle = row;
    io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* Nur zeigen, wenn die Leiste OBERHALB des Viewports liegt (also beim
         Runterscrollen passiert) — nicht, solange sie unterhalb noch kommt. */
      var above = e.boundingClientRect.top < 0;
      setVisible(!e.isIntersecting && above);
    }, { threshold: 0 });
    io.observe(row);
  }

  function init() {
    if (!realButton()) return; // keine Filterleiste auf dieser Seite
    ensureFab();
    updateBadge();
    observe();

    window.addEventListener('popstate', updateBadge);
    window.addEventListener('pageshow', updateBadge);

    /* Breakpoint-Wechsel: der sichtbare Anker wechselt zwischen Mobile-
       Leiste und Desktop-Button -> Observer neu anbinden. */
    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () { observedToggle = null; observe(); }, 250);
    });

    /* Nach AJAX-Filterung rendert Horizon die Ergebnisliste (und damit ggf.
       die Filterleiste) neu -> Badge aktualisieren und Observer neu anbinden. */
    var results = document.querySelector('results-list, collection-component, main');
    if (results) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          updateBadge();
          observe();
        }, 200);
      }).observe(results, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
